import { ReactNode } from "react";

import { DialogControlContext, DialogDataContext } from "../context";
import { useDialogStore } from "../hooks/useDialogStore";

export const DialogContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const dialogStore = useDialogStore();
  return (
    <DialogControlContext.Provider value={dialogStore.control}>
      <DialogDataContext.Provider value={dialogStore.data}>
        {children}
      </DialogDataContext.Provider>
    </DialogControlContext.Provider>
  );
};
